import styled from 'styled-components'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const Container = styled.div`
  margin: 0px 5px;
  /* background-color: blueviolet !important; */
  height: 100%;

  div.ui.card {
    width: 100%;
  }

  div.ui.card div.content:nth-child(2n) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  form {
    width: 100%;
  }

  .fields_personalizados {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;

    div.field {
      width: 50%;
    }

    div.field2 {
      width: 100%;
    }
    div.buttons {
      display: flex;
      justify-content: start;
      align-items: center;
      padding-top: 2px;
      padding-bottom: 2px;
    }

    div.select-button {
      display: flex;
      justify-content: center;
      align-items: end;
      width: 50%;
      gap: 10px;
    }
  }
`
